import React from 'react';
import { Box, Typography, Stack, IconButton, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import FavoriteIcon from '@mui/icons-material/Favorite';
import BlockchainNetwork from './BlockchainNetwork';

const FooterContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(6, 0, 4),
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  overflow: 'hidden'
}));

const FooterContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  maxWidth: '1200px',
  margin: '0 auto',
  padding: theme.spacing(0, 4)
}));

const SocialButton = styled(IconButton)(({ theme }) => ({
  width: '45px',
  height: '45px',
  borderRadius: '50%',
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 20px rgba(0, 102, 204, 0.3)'
  }
}));

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <GitHubIcon />,
      href: 'https://github.com/mertdalkir',
      label: 'GitHub'
    },
    {
      icon: <LinkedInIcon />,
      href: 'https://linkedin.com/in/mertdalkir',
      label: 'LinkedIn'
    },
    {
      icon: <EmailIcon />,
      href: 'mailto:mert@example.com',
      label: 'Email'
    }
  ];

  return (
    <FooterContainer>
      <BlockchainNetwork />
      
      <FooterContent>
        <Stack spacing={4} alignItems="center">
          {/* Social Links */}
          <Stack direction="row" spacing={3}>
            {socialLinks.map((link, index) => (
              <SocialButton
                key={index}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
              >
                {link.icon}
              </SocialButton>
            ))}
          </Stack>

          <Divider sx={{ width: '100%', maxWidth: '400px' }} />

          {/* Footer Text */}
          <Stack spacing={2} alignItems="center" textAlign="center">
            <Typography variant="h6" fontWeight={600}>
              Mert Dalkır
            </Typography>
            <Typography variant="body2" color="text.secondary">
              AI & Web3 Developer | Blockchain Enthusiast | Full Stack Engineer
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body2" color="text.secondary">
                Made with
              </Typography>
              <FavoriteIcon sx={{ color: 'error.main', fontSize: '1rem' }} />
              <Typography variant="body2" color="text.secondary">
                using React, TypeScript & MUI
              </Typography>
            </Stack>
          </Stack>

          <Divider sx={{ width: '100%', maxWidth: '400px' }} />

          {/* Copyright */}
          <Typography variant="body2" color="text.secondary" textAlign="center">
            © {currentYear} Mert Dalkır. Tüm hakları saklıdır.
          </Typography>
        </Stack>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;